export var TypeActionPaymentEntryInfo;
(function (TypeActionPaymentEntryInfo) {
    TypeActionPaymentEntryInfo["RequestPaymentEntryInfo"] = "ActionPaymentEntryInfo > RequestPaymentEntryInfo";
    TypeActionPaymentEntryInfo["SetPaymentEntryInfo"] = "ActionPaymentEntryInfo > SetPaymentEntryInfo";
})(TypeActionPaymentEntryInfo || (TypeActionPaymentEntryInfo = {}));
export var actionRequestPaymentEntryInfo = function (ids) { return ({
    ids: ids,
    type: TypeActionPaymentEntryInfo.RequestPaymentEntryInfo,
}); };
export var actionSetPaymentEntryInfo = function (offers) { return ({
    offers: offers,
    type: TypeActionPaymentEntryInfo.SetPaymentEntryInfo,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/payment-entry-info/actionPaymentEntryInfo.ts
// module id = 563
// module chunks = 3